
export const searchReducer = (state = {}, action) => {
    switch(action.type){
        case "search/set": {
            return action.payload;
        }
        default:
            return state
    }
}